import { Typography } from "@mui/material";

const serviceDetails = {
    banner: {
        title: "Mperito Service",
        subTitle: "Provide seamless service experience to your customers with your own branded app",
        button1Label: "Get Started",
        button2Label: "Request Demo",
        backgroundImage: "/assets/solutions/service/mperito_service_banner.jpg"
    },
    sectionHeading: {
        title: <span>
            Your Own Branded Service App!{' '}
            <Typography component="span" variant="inherit" color="primary">
                Solution Is Here
            </Typography>
        </span>,
        subTitle: "Essential Pages and features to ensure your service offerings are completely digital including streamlined backend operations"
    },
    features: [
        {
            label: 'BRANDING',
            title: 'Essential Pages',
            description:
                'All the important pages to display your services and content',
            illustration: '/assets/images/solution/shop/essential_pages_sm.jpg',
            list: [
                "Homepage",
                "Service Listing",
                "Service Details Page",
                "Contact Page",
                "About Page",
                "All Policy Pages"
            ]
        },
        {
            label: 'OPERATIONS',
            title: 'Manage Transactions',
            description:
                'All vital pages that enables customer to transact and book service',
            illustration: '/assets/images/solution/enablement.jpg',
            list: [
                "Single Cart view across channels",
                "Book Service along with slot confirmation",
                "Confirm Preferred Location of Service",
                "Service completion confirmation with customer OTP",
                "Addresses"
            ]
        },
        {
            label: 'ANALYSE',
            title: 'Insights',
            description:
                'As the transactions take place the vital statistics available for decision making',
            illustration: '/assets/images/solution/shop/insights_sm.jpg',
            list: [
                "Order Insights",
                "Revenue Insights",
                "Trends on services Sales",
                "Valued Customers"
            ],
        },
        {
            label: 'SETUP',
            title: 'Configure Digital Store',
            description:
                'Setup your store with simplified screens',
            illustration: '/assets/images/solution/shop/setup_sm.jpg',
            list: [
                "Categories & Services",
                "Service Slots",
                "Service Pricing",
                "Service Team Setup",
                "Payment Gateway",
                "Contact Details",
                "Branding Theme",
                "News & Communications"
            ],
        },
        {
            label: 'CONTROL',
            title: "Service Command Centre",
            description:
                'Get in control of the complete business at your finger tips',
            illustration: '/assets/images/solution/shop/command_center_sm.jpg',
            list: [
                "Leverage your mobile or tablet as Command Centre",
                "Track & Monitor progress of all booked services",
                "Book service on behalf of customer",
                "Generate and Print Bills / Invoices",
                "View and Process Orders",
                "Manage Categories, Services, Pricing & Team"
            ],
        },
        {
            label: 'VALUE',
            title: "What\'s More",
            description:
                'The value genenrated by going online with MPERITO',
            illustration: '/assets/images/solution/shop/mperito_values_sm.jpg',
            list: [
                "Mobile Validated Genuine customers",
                "Sharing of Services to friends and family",
                "Reviews and Rating against the service",
                "Order copy for service",
                "GST Tax Invoice generated automatically"
            ],
        }
    ]
}

export default serviceDetails;